import type { UseTranslationResponse } from 'react-i18next';
import { useTranslation } from 'react-i18next';

const namespace = 'features';
export const keyPrefix = 'verify_face';
export const useVerifyFaceTranslation = (): UseTranslationResponse<typeof namespace, typeof keyPrefix> => {
  return useTranslation(namespace, { keyPrefix });
};

export const ruRu = ({
  [keyPrefix]: {
    verify_button: 'Сравнить',
  },
}) as Record<string, unknown>;
export const en = ({
  [keyPrefix]: {
    verify_button: 'Compare',
  },
}) as Record<string, unknown>;
export const ptBr = ({
  [keyPrefix]: {
    verify_button: 'Comparar',
  },
}) as Record<string, unknown>;
export const esEs = ({
  [keyPrefix]: {
    verify_button: 'Comparar',
  },
}) as Record<string, unknown>;
